export interface Persona {
  name: string;
  slug: string;
  emoji: string;
  accentColor: string;
}

export const personaAvatars: Record<string, string> = {
  mozart: "/avatars/mozart-avatar.webp",
  davinci: "/avatars/davinci-avatar.webp",
  picasso: "/avatars/picasso-avatar.webp",
};

export const personas: Persona[] = [
  {
    name: "Mozart",
    slug: "mozart",
    emoji: "🎼",
    accentColor: "#6366f1",
  },
  {
    name: "Da Vinci",
    slug: "davinci",
    emoji: "🔭",
    accentColor: "#818cf8",
  },
  {
    name: "Picasso",
    slug: "picasso",
    emoji: "🎨",
    accentColor: "#ef4444",
  },
];
